import { render, staticRenderFns } from "./paygoodsItem.vue?vue&type=template&id=784ead7c&scoped=true"
import script from "./paygoodsItem.vue?vue&type=script&lang=js"
export * from "./paygoodsItem.vue?vue&type=script&lang=js"
import style0 from "./paygoodsItem.vue?vue&type=style&index=0&id=784ead7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ead7c",
  null
  
)

export default component.exports